import { render, staticRenderFns } from "./OnboardingLanding.vue?vue&type=template&id=5f091a1c"
import script from "./OnboardingLanding.vue?vue&type=script&lang=js"
export * from "./OnboardingLanding.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports